import { useEffect } from 'react'
import * as Sentry from '@sentry/tanstackstart-react'
import { createFileRoute, type ErrorComponentProps } from '@tanstack/react-router'
import AuthGuard from '../components/AuthGuard'
import { DevicesListClient } from '../components/DevicesListClient'
import { prefetchDevices } from '../lib/route-prefetch'

function DevicesError({ error }: ErrorComponentProps) {
  useEffect(() => { Sentry.captureException(error) }, [error])
  return (
    <div className="p-8 text-center text-gray-600">
      Failed to load devices.{' '}
      <button onClick={() => window.location.reload()} className="text-brand underline">
        Retry
      </button>
    </div>
  )
}

export const Route = createFileRoute('/devices/')({
  head: () => ({
    meta: [{ title: 'Devices | Unbreakable' }],
  }),
  validateSearch: (search: Record<string, unknown>): { add?: boolean } => ({
    add: search.add === 'true' || search.add === true ? true : undefined,
  }),
  beforeLoad: ({ context }) => {
    prefetchDevices(context.queryClient)
  },
  errorComponent: DevicesError,
  component: DevicesPage,
})

function DevicesPage() {
  const { add } = Route.useSearch()
  return (
    <AuthGuard>
      <DevicesListClient showAddModal={add} />
    </AuthGuard>
  )
}
